const resolveApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (typeof window !== "undefined" && window.location?.hostname) {
    const hostname = window.location.hostname;
    if (hostname !== "localhost" && hostname !== "127.0.0.1") {
      // If envUrl is explicitly a remote cloud domain (e.g. https://api.dealvoicecrm.com), keep it
      if (envUrl && !envUrl.includes("localhost") && !envUrl.includes("127.0.0.1")) {
        return envUrl;
      }
      // In local network testing, route API calls to the same host machine on port 4001
      const protocol = window.location.protocol || "http:";
      return `${protocol}//${hostname}:4001`;
    }
  }
  return envUrl || "http://localhost:4001";
};

export const API_BASE_URL = resolveApiBaseUrl();

export const FRONTEND_BASE_URL =
  process.env.REACT_APP_FRONTEND_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");

export const WE_CRM_ACCESS =
  process.env.REACT_APP_WE_CRM_ACCESS || "";

export const WE_CRM_URL =
  process.env.REACT_APP_WE_CRM_URL || "https://aistartupdoctor.com/api";

export const API_ENDPOINTS = {
  AUTH_LOGIN: `${API_BASE_URL}/api/auth/login`,
  ADMIN_LOGIN: `${API_BASE_URL}/api/admin/login`,
  EMPLOYEE_LOGIN: `${API_BASE_URL}/api/employees/login`,
  CALL_LOGS_SUMMARY: `${API_BASE_URL}/api/call-logs/summary`,
  CALL_LOGS_TIMELINE: `${API_BASE_URL}/api/call-logs/timeline`,
  CALL_LOGS_EMPLOYEES: `${API_BASE_URL}/api/call-logs/employees`,
  INVOICES: `${API_BASE_URL}/api/invoices`,
  QUOTATIONS: `${API_BASE_URL}/api/quotations`,
  PROPOSALS: `${API_BASE_URL}/api/proposal-records`,
  PROPOSAL_RECORDS: `${API_BASE_URL}/api/proposal-records`,
  EMPLOYEES: `${API_BASE_URL}/api/employees`,
  CLIENTS: `${API_BASE_URL}/api/clients`,
  LEADS: `${API_BASE_URL}/api/leads`,
};
